var _g, _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1399_1548)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5776 8.75488C21.5786 9.02984 21.6589 13.0035 25.829 13.2513C25.829 14.3972 25.8304 15.2281 25.8304 16.3216C25.5146 16.3399 23.0851 16.1635 21.573 14.8148L21.5684 20.7919C21.6258 24.9405 18.5728 27.4651 14.5823 26.5931C7.70103 24.5346 9.98762 14.3286 16.897 15.421C16.897 18.7159 16.8988 15.42 16.8988 18.7159C14.0443 18.2959 13.0896 20.6705 13.8482 22.3706C14.5383 23.9185 17.3804 24.254 18.3718 22.0702C18.4841 21.6429 18.5401 21.1556 18.5401 20.6085V8.73975L21.5776 8.75488Z",
    fill: "white"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.1252,
    cy: 18.0251,
    r: 17.6496,
    stroke: "#5D5D5D",
    strokeWidth: 0.751047
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1399_1548"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.0251,
    height: 18.0251,
    fill: "white",
    transform: "translate(9.11426 8.73975)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.d688263a51ba273c699f824be9d3c3ed.svg";
export { ForwardRef as ReactComponent };